import React, { useEffect } from 'react';
import './psbienyprod2024.css';
import { psbienyprod2024 } from '../../json/psbienyprod2024';

const Psbienyprod2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Bienestar y Producción 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                EI presente Programa fortalece y vincula entre sí y con los diversos órganos de gobierno a los Colectivos Comunitarios, propiciando el empoderamiento económico, apoyando a individuos y colectivos en situaciones de carencia social para desarrollar proyectos productivos sostenibles.
                </p>
                <p>
                Además de impulsar proyectos que tengan un impacto positivo en la comunidad, mejorando los índices de bienestar y reduciendo la pobreza y rezago; y la inclusión social, dando prioridad a la creación de empleos y oportunidades para personas en situación de vulnerabilidad dentro de los proyectos apoyados.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Fomentar el desarrollo de proyectos productivos liderados por personas o grupos en situación de vulnerabilidad, con el fin de generar bienestar económico y social en sus comunidades, abatiendo los índices de pobreza y rezago.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Grupos de hasta 10 personas de los 84 municipios del Estado de Hidalgo, agrupados en las 12 regiones contenidas en el Plan Estatal de Desarrollo 2022-2028, preferentemente de localidades de Alta y Muy Alta marginación y población en situación de pobreza y vulnerabilidad.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa tendrá cobertura en los 84 municipios del Estado de Hidalgo agrupados en las 12 regiones contenidas en el Plan Estatal de Desarrollo 2022-2028. Los apoyos se otorgarán conforme a la capacidad que permita la infraestructura y disponibilidad presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Desarrollo Social y Humano<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                L. D. Ricardo Gómez Moreno: Secretario de la SEBISO
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 717 8000 Ext. 8948
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Bienestar_Producci%C3%B3n_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                </ul>

                  <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatorias</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_BP_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2024/CONV_BP_OCT24.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/CONV_BP_OCT24_A1.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 1.- Solicitud de Apoyo</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/CONV_BP_OCT24_A2.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 2.- Plan productivo</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/CONV_BP_OCT24_A3.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 3.- Acta de integración</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/CONV_BP_OCT24_A4.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 4.- Cuestionario Socioeconómico</a>
                </li>

                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2024/CONV_BP_OCT24_A5.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 5.- Listado de integrantes</a>
                </li>

                </ul>
                </li>
                </ul><p></p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                  <li>
                <a
                href='https://amigosdelatransformacion.com.mx/pro.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                  <li>
                <a
                href='/Folios/Byp1024'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Enlaces a los catálogos estatal y nacional</h5>
                <ul>
                  <li>
                <a
                href='https://ruts.hidalgo.gob.mx/ver/11203'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Registro Único de Trámites y Servicios (RUTS)</a>
                </li>
                <li>
                <a
                href='https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-020-A'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Catalogo Nacional de Regulaciones Trámites y Servicios (CNARTyS)</a>
                </li>
                </ul>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>


      </div>    
    </div>
  );
};

export default Psbienyprod2024;